var path = '/modules/bo/objects/views/list.tpl.html';
var html = "<listview store=\"vm.store\"></listview>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/bo/objects/views/list.tpl.html
// module id = 2063
// module chunks = 1